import React, {useState} from "react";
import Switch from "react-bootstrap-switch";
import {CardBody, Col, Form, FormGroup, Label, Row} from "reactstrap";
import {connect, useSelector} from "react-redux";
import {useForm} from "react-hook-form";


// components
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";

// labels
import {FL_ONLY_REGISTERED, FL_STATUS} from "../../../components/i18n/formLabels";

// actions
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";
import SelectGeneric from "../../../components/select/selectGeneric";
import {placeProvider} from "../../../providers/placeProvider";
import {aybMenuProvider} from "../../../providers/ayb/aybMenuProvider";



const DishDrinkFilters = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter, app, udn, category, userIsAdmin } = componentState?.data || {};

    const [status, setStatus] = useState(filter?.status || null);
    const [onlyRegistered, setOnlyRegistered] = useState(true);
    const [aybMenuId, setAybMenuId] = useState(filter?.aybMenu?.id);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            code: ''
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            onlyRegistered: onlyRegistered,
            fbDataBase : { id : app?.fbDataBase?.id },
            item :  {
                ...data,
                category : category,
                udn : { id : udn.id }
            }
        };

        if ( (aybMenuId !== undefined && aybMenuId !== null) || (filter?.item?.place?.id) )
            dataFilter.item.place = { id : aybMenuId || filter?.item?.place?.id};

        if (status !== undefined && status !== null)
            dataFilter.item.status = status;

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        setStatus(null);
        setAybMenuId(null);
        setOnlyRegistered(true);
        reset({
            code: ''
        });
    }

    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <CardBody>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>{ 'Menu' }</Label>
                        <SelectGeneric
                            initialValue={aybMenuId || filter?.item?.place?.id}
                            setExternalValue={value => setAybMenuId(value)}
                            isDisabled={false}
                            provider={aybMenuProvider}
                            customFilter={{ item : {udn: {id: udn.id}, categoryCodes : category}} }
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>{FL_STATUS}</Label>
                        <br/>
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={status}
                            onChange={ () => setStatus(!status) }
                        />
                    </FormGroup>
                </Col>
                {
                    userIsAdmin ?
                        <Col md="3">
                            <FormGroup>
                                <Label>{FL_ONLY_REGISTERED}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={onlyRegistered}
                                    onChange={() => setOnlyRegistered(!onlyRegistered)}
                                />
                            </FormGroup>
                        </Col> : null
                }
            </Row>

            <Row>
                <Col md="12" className="d-flex justify-content-center">
                    <div className="float-right">
                        <ButtonSearch/>
                        <ButtonClean onClick={cleanFields}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(DishDrinkFilters)